import React from "react";
import PropTypes from "prop-types";

const Money = ({ value = 0, className, showDecimals, isDiscount }) => {
  const fixedNum = showDecimals ? 2 : 0;
  const numericValue = Number(value);
  const absValue = Math.abs(numericValue)
    .toFixed(fixedNum)
    .replace(/./g, (c, i, a) =>
      i && c !== "." && (a.length - i) % 3 === 0 ? `,${c}` : c
    );

  return (
    <span className={className}>
      <span style={{ textDecoration: isDiscount ? "line-through" : "none" }}>
        {numericValue < 0 ? "-" : ""}
        <span className="dollar-sign">$</span>
        {absValue}
      </span>{" "}
      {isDiscount && "FREE"}
    </span>
  );
};

Money.defaultProps = {
  value: 0,
  className: "",
  showDecimals: true,
};

Money.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.any,
  showDecimals: PropTypes.bool,
  isDiscount: PropTypes.bool,
};

export default Money;
